import type { StateCode } from "./types";

/** Maps state prefix digits to state codes (ordered: longer prefixes first for correct matching) */
const statePrefixEntries: [string, StateCode[]][] = [
  ["28", ["DE-BW"]],
  ["27", ["DE-RP"]],
  ["26", ["DE-HE"]],
  ["24", ["DE-HB"]],
  ["23", ["DE-NI"]],
  ["22", ["DE-HH"]],
  ["21", ["DE-SH"]],
  ["11", ["DE-BE"]],
  ["9", ["DE-BY"]],
  ["5", ["DE-NW"]],
  ["4", ["DE-TH", "DE-MV"]],
  ["3", ["DE-BB", "DE-SN", "DE-ST"]],
  ["1", ["DE-SL"]],
];

/** Maps a StateCode to its prefix in the national format */
export const stateToPrefix: Record<StateCode, string> = {
  "DE-BW": "28",
  "DE-BY": "9",
  "DE-BE": "11",
  "DE-BB": "3",
  "DE-SN": "3",
  "DE-ST": "3",
  "DE-HB": "24",
  "DE-HH": "22",
  "DE-HE": "26",
  "DE-MV": "4",
  "DE-TH": "4",
  "DE-NI": "23",
  "DE-NW": "5",
  "DE-RP": "27",
  "DE-SL": "1",
  "DE-SH": "21",
};

export const statesWith10Digits: ReadonlySet<StateCode> = new Set([
  "DE-BW",
  "DE-BE",
  "DE-HB",
  "DE-HH",
  "DE-NI",
  "DE-RP",
  "DE-SH",
]);

export const statesWith11Digits: ReadonlySet<StateCode> = new Set([
  "DE-BY",
  "DE-BB",
  "DE-HE",
  "DE-MV",
  "DE-NW",
  "DE-SL",
  "DE-SN",
  "DE-ST",
  "DE-TH",
]);

export const bayerischerProgrammierverbundStates: ReadonlySet<StateCode> =
  new Set(["DE-BY", "DE-BB", "DE-MV", "DE-SL", "DE-SN", "DE-ST", "DE-TH"]);

/** Derives the state(s) from a 12+ digit national format number by matching the prefix */
export function getStatesFromDigits(digits: string): StateCode[] {
  for (const [prefix, states] of statePrefixEntries) {
    if (digits.startsWith(prefix)) {
      return states;
    }
  }
  return [];
}

/** Derives the state prefix from a list of states. Throws if no matching prefix found. */
export function getStatesPrefix(states: StateCode[]): string {
  for (const state of states) {
    const prefix = stateToPrefix[state];
    if (prefix !== undefined) {
      return prefix;
    }
  }
  throw new Error("Die Steuernummer kann keinem Bundesland zugewiesen werden");
}
